import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

class ReviewsSettings extends Component {
    constructor(props) {
        super(props);
    }

    renderIncrementalSetting = (label, value, name, step = 1, min = 0) => {
        let displayValue = value;
        let unit = 'px';

        if (name === 'reviews.maxTextLength') {
            unit = '';
        }

        if (typeof value === 'string') {
            const match = value.match(/^([\d.]+)(.*)$/);
            if (match) {
                displayValue = match[1];
            }
        }

        return (
            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>{label}</label>
                </div>
                <div className='mjwi-col50'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            name={name}
                            value={displayValue || ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.props.handleInputChange({ target: { name, value: val ? `${parseFloat(val) || 0}${unit}` : `0${unit}` } }, ['reviews']);
                            }}
                            className="mjwi-input"
                            min={min}
                            style={{ flexGrow: 1 }}
                        /> {unit}
                    </div>
                </div>
            </div>
        );
    };

    renderColorPicker = (label, color, field) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50 mjwi-clr-picker">
                <span
                    className="clrPickerVal"
                    onClick={toggleColorPicker}
                    style={{ backgroundColor: color }}
                ></span>
                <HexAlphaColorPicker
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('reviews', field, newColor)}
                    className="mjwi-apfl-color-picker"
                    style={{ display: 'none' }}
                />
                <HexColorInput
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('reviews', field, newColor)}
                    className="mjwi-color-input"
                />
            </div>
        </div>
    );

    renderDropdown = (label, name, value, options) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50">
                {getSelectField(name, options.map(opt => opt.label), value, (e) => this.props.handleInputChange(e, ['reviews']))}
            </div>
        </div>
    );

    renderTextInput = (label, name, value, placeholder) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50">
                <input
                    type="text"
                    name={name}
                    value={value}
                    onChange={(e) => this.props.handleInputChange(e, ['reviews'])}
                    placeholder={placeholder}
                    className="mjwi-input"
                />
            </div>
        </div>
    );

    renderReviewerInfo = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.reviewerNameColor, 'reviewerNameColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.reviewerNameFontSize, 'reviews.reviewerNameFontSize', 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.reviewerNameFontFamily', tripadvisor.reviews.reviewerNameFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.reviewerNameFontBold', tripadvisor.reviews.reviewerNameFontBold, fontWeightOptions)}
            </div>
        );
    };

    renderStars = () => {
        const { tripadvisor } = this.props;
        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Star Color', tripadvisor.reviews.starColor, 'starColor')}
                {this.renderColorPicker('Empty Star Color', tripadvisor.reviews.starEmptyColor, 'starEmptyColor')}
                {this.renderIncrementalSetting('Star Size', tripadvisor.reviews.starSize, 'reviews.starSize', )}
            </div>
        );
    };

    renderReviewDate = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.reviewDateColor, 'reviewDateColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.reviewDateFontSize, 'reviews.reviewDateFontSize',1, 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.reviewDateFontFamily', tripadvisor.reviews.reviewDateFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.reviewDateFontWeight', tripadvisor.reviews.reviewDateFontWeight, fontWeightOptions)}
            </div>
        );
    };

    renderReviewTitle = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.reviewTitleColor, 'reviewTitleColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.reviewTitleFontSize, 'reviews.reviewTitleFontSize', 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.reviewTitleFontFamily', tripadvisor.reviews.reviewTitleFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.reviewTitleFontBold', tripadvisor.reviews.reviewTitleFontBold, fontWeightOptions)}
            </div>
        );
    };

    renderReviewText = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.reviewTextColor, 'reviewTextColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.reviewTextFontSize, 'reviews.reviewTextFontSize', 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.reviewTextFontFamily', tripadvisor.reviews.reviewTextFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.reviewTextFontWeight', tripadvisor.reviews.reviewTextFontWeight, fontWeightOptions)}
            </div>
        );
    };

    renderReadMore = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.readMoreColor, 'readMoreColor')}
                {this.renderColorPicker('Hover Color', tripadvisor.reviews.readMoreHoverColor, 'readMoreHoverColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.readMoreFontSize, 'reviews.readMoreFontSize', 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.readMoreFontFamily', tripadvisor.reviews.readMoreFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.readMoreFontWeight', tripadvisor.reviews.readMoreFontWeight, fontWeightOptions)}
            </div>
        );
    };

    renderTripType = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.reviews.tripTypeColor, 'tripTypeColor')}
                {this.renderIncrementalSetting('Font Size', tripadvisor.reviews.tripTypeFontSize, 'reviews.tripTypeFontSize', 1, 8)}
                {this.renderDropdown('Font Family', 'reviews.tripTypeFontFamily', tripadvisor.reviews.tripTypeFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'reviews.tripTypeFontWeight', tripadvisor.reviews.tripTypeFontWeight, fontWeightOptions)}
            </div>
        );
    };

    renderReviewCard = () => {
        const { tripadvisor } = this.props;

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Background Color', tripadvisor.reviews.reviewBackgroundColor, 'reviewBackgroundColor')}
                {this.renderColorPicker('Border Color', tripadvisor.reviews.reviewBorderColor, 'reviewBorderColor')}
                {this.renderIncrementalSetting('Border Radius', tripadvisor.reviews.reviewBorderRadius, 'reviews.reviewBorderRadius', 1, 0)}
                {this.renderIncrementalSetting('Padding', tripadvisor.reviews.reviewPadding, 'reviews.reviewPadding', 1, 0)}
            </div>
        );
    };

    renderReviewsSettings = () => {
        const { tripadvisor } = this.props;
        return (
            <Accordion allowZeroExpanded={true}>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Review Card
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderReviewCard()}
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Reviewer Info
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderReviewerInfo()}
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Stars
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderStars()}
                    </AccordionItemPanel>
                </AccordionItem>
                {tripadvisor.reviews.showReviewDate && (
                    <AccordionItem className='mjwi-sub-accordion'>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                Review Date
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            {this.renderReviewDate()}
                        </AccordionItemPanel>
                    </AccordionItem>
                )}
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Review Title
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderReviewTitle()}
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Review Text
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderReviewText()}
                    </AccordionItemPanel>
                </AccordionItem>
                <AccordionItem className='mjwi-sub-accordion'>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            Read More
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {this.renderReadMore()}
                    </AccordionItemPanel>
                </AccordionItem>
                {tripadvisor.reviews.showTripType && (
                    <AccordionItem className='mjwi-sub-accordion'>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                Trip Type
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            {this.renderTripType()}
                        </AccordionItemPanel>
                    </AccordionItem>
                )}
            </Accordion>
        );
    };

    render() {
        return this.props.renderSection('Reviews', this.renderReviewsSettings(), 'reviews-settings');
    }
}

export default ReviewsSettings;